var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KTextbox',{attrs:{"label":"Numbers only","invalid":!_vm.isNumeric(_vm.numericInput),"invalidText":"Please enter a valid number.","showInvalidText":""},model:{value:(_vm.numericInput),callback:function ($$v) {_vm.numericInput=$$v},expression:"numericInput"}})
}
var staticRenderFns = []

export { render, staticRenderFns }